import React, { useEffect, useState } from "react";
import { Col, Container, Nav, Row, Tab } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import FadeLoader from "react-spinners/FadeLoader";
import moment from "moment";

const FlagMessageView = () => {
  const location = useLocation();
  const data = location.state?.userData;
  return (
    <>
      <section className="addForm position-relative py-4">
        <Container>
          <Row className="">
            {data?.flagMessages?.map((flag, index) => (
              <Col md="4" className="my-2" key={index}>
                <div className="flex-grow-1 d-flex flex-column">
                  <div className="cardCstm p-3 border rounded-4 bg-light shadow-sm h-100">
                    <div className="top pt-2 pb-3 border-bottom border-secondary">
                      <h5 className="m-0 fw-bold themeClr">
                        {flag?.character?.name}
                      </h5>
                    </div>
                    <div className="imgWrp justify-content-center mt-3">
                      <img
                        src={flag?.character?.image || "placeholder.png"}
                        alt=""
                        style={{ height: "300px" }}
                        className="w-100 h-100 object-fit-cover rounded"
                      />
                    </div>
                    <div className="messageWrp mt-3">
                      <h6 className="fw-semibold text-dark">Flag Message:</h6>
                      <p className="text-muted" style={{ fontSize: "14px" }}>
                        {flag?.message}
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </>
  );
};
export default FlagMessageView;
